<select class="form-control" [(ngModel)]="viewByModel" (ngModelChange)="onModelChanged()" *ngIf="!config.isCxOne">
    <option *ngFor="let item of options" [ngValue]="item">{{ item.display }}</option>
</select>
<cxone-singleselect-dropdown *ngIf="config.isCxOne"
    [(ngModel)]="viewByModel"
    [options]="options"
    (ngModelChange)="onModelChanged()"
    label="display"
    primaryKey="id"
    sortKey="index"
    sortOrder="asc"
    [isRequired]="false"
    [showFooter]="false"
    [search]="false"
    [maxItemsToDisplay]="1000"
></cxone-singleselect-dropdown>
